module.exports = __webpack_public_path__ + "static/default_thumbnail-e611543dec7755844ce9e46fe38b0b9c.png";